import React from 'react';
import { Editor, EditorProps } from 'react-draft-wysiwyg';
import classNames from 'classnames';

interface Props extends EditorProps {
	className?: string;
	wrapperClassName?: string;
}

export const HtmlEditor: React.FC<Props> = ({ editorRef, className, wrapperClassName, ...props }) => (
	<Editor
		ref={editorRef}
		{...props}
		editorClassName={classNames('ee-rich-text-editor', className)}
		wrapperClassName={classNames('ee-rich-text-editor__root', wrapperClassName)}
	/>
);
